import React, { createContext, useContext, useState } from "react";
import { patchRequest, postRequest } from "services/api";
import { ACTION_TYPES, URLS } from "utils/constants";

const ProductCreateContext = createContext();

export const ProductCreateProvider = ({ children }) => {
  const [product, setProduct] = useState({
    form: {
      name: "",
      price: 0,
      price_sale: 0,
    },
    data: null,
    loading: false,
    error: null,
    isSubmitting: false,
    mode: ACTION_TYPES.CREATE,
  });

  const createProduct = async () => {
    setProduct((prevState) => ({
      ...prevState,
      isSubmitting: true,
    }));

    try {
      const response = await postRequest("/product", product.form);
      console.log(response);
      if (response.success) {
        setProduct((prevState) => ({
          ...prevState,
          data: response.data,
          error: null,
          isSubmitting: false,
        }));

        return { success: true, data: response };
      }
    } catch (error) {
      setProduct((prevState) => ({
        ...prevState,
        error: "Failed to create product",
        isSubmitting: false,
      }));

      return { success: false, error: error };
    }
  };

  const updateProduct = async (id) => {
    setProduct((prevState) => ({
      ...prevState,
      isSubmitting: true,
    }));

    try {
      const response = await patchRequest(`/product/${id}`, product.form);
      if (response.success) {
        setProduct((prevState) => ({
          ...prevState,
          data: response.data,
          error: null,
          isSubmitting: false,
        }));

        return { success: true, data: response };
      }
    } catch (error) {
      setProduct((prevState) => ({
        ...prevState,
        error: "Failed to update product",
        isSubmitting: false,
      }));

      return { success: false, error: error };
    }
  };

  return (
    <ProductCreateContext.Provider
      value={{
        product,
        setProduct,
        createProduct,
        updateProduct,
      }}
    >
      {children}
    </ProductCreateContext.Provider>
  );
};

export const useProductCreate = () => {
  const context = useContext(ProductCreateContext);

  if (!context) {
    throw new Error(
      "useProductCreate must be used within ProductCreateProvider"
    );
  }

  return context;
};
